import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../images/logos/jah-logo5-1.png";
import '../css/header.css';
import PropTypes from "prop-types";

export default class Navigation extends React.Component {
  static propTypes = {
    pages: PropTypes.array
};

  
  render() {
    return (
      <div class="header">
        <div class="tape-section"></div>
        <div class="header-inner-wrapper">
          <div class="logo">
          <span class="nav-button"><Link to="/"><img src={logo} alt="James A. Hillebrecht" /></Link></span>
            </div>
          <div class="navigation">
            { this.props.pages.map((page, i) => (
              <span class="nav-button" ><Link to={page}>{page}</Link></span>
            )) }
            <a class="nav-button" href="https://blog.jamesahillebrecht.com/">BLOG</a>
            <a class="nav-button" href="https://www.amazon.com/stores/James-A.-Hillebrecht/author/B0BH371GYL">BUY</a>
          </div>
        </div>
        <div class="tape-section"></div>
      </div>
    )
  }
}

